module.exports = __webpack_public_path__ + "static/img/feihe.f4ee8b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/feihe.jpg
// module id = NCMo
// module chunks = 0